import { render, staticRenderFns } from "./MultiVideoMp4.vue?vue&type=template&id=2748d59c&scoped=true&"
import script from "./MultiVideoMp4.vue?vue&type=script&lang=js&"
export * from "./MultiVideoMp4.vue?vue&type=script&lang=js&"
import style0 from "./MultiVideoMp4.vue?vue&type=style&index=0&id=2748d59c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2748d59c",
  null
  
)

export default component.exports